import { ActivateDeactiveteContactRequest, ActivateDeactiveteClientAccountRequest } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import useDataFetchIndicator from '@/hooks/useDataFetchIndicator';
import { useClientData } from '@/providers/ClientData.provider';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostSubmitUserSettings() {
    const [, setDataFetchingInfo] = useDataFetchIndicator();
    const source = axios.CancelToken.source();

    const { response } = useClientData();
    const [accountTypeLabel, setAccountTypeLabel] = useState<'Client Account' | 'Contact'>('Client Account');

    useEffect(() => {
      if (response.clientAccountsEnabled) {
        setAccountTypeLabel('Client Account');
      } else {
        setAccountTypeLabel('Contact');
      }
    }, [response]);

    const activateAccount = async (
      requestParams: ActivateDeactiveteClientAccountRequest | ActivateDeactiveteContactRequest,
    ) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');

        if (response.clientAccountsEnabled) {
          return await api.activateClientAccount(requestParams as ActivateDeactiveteClientAccountRequest, source);
        } else {
          return await api.activateContact(requestParams as ActivateDeactiveteContactRequest, source);
        }
      } finally {
        setDataFetchingInfo(false);
      }
    };

    const deactivateAccount = async (
      requestParams: ActivateDeactiveteClientAccountRequest | ActivateDeactiveteContactRequest,
    ) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');

        if (response.clientAccountsEnabled) {
          return await api.deactivateClientAccount(requestParams as ActivateDeactiveteClientAccountRequest, source);
        } else {
          return await api.deactivateContact(requestParams as ActivateDeactiveteContactRequest, source);
        }
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      accountTypeLabel,
      activateAccount,
      deactivateAccount,
    };
  };
});
export default hook({});
